import { useState } from 'react';

const name = {
  commentInput: 'commentInput',
};

const useForm = ({ initialValues, onSubmit, validate }) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    //   이렇게하면 동적으로 사용가능합니다.
    if (e.target.files) {
      const changeImg = { name: 'image', value: e.target.files[0] };
      setValues({ ...values, [changeImg.name]: changeImg.value });

      return;
    }
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    //댓글작성 시 Input창 초기화 다른 창들 초기화 하고싶다면 객체로 만들어서 다루면됨.
    if (e.target.name === name.commentInput) {
      document.getElementById(name.commentInput).value = '';
    }

    const newErrors = validate ? validate(values) : {};
    setErrors(newErrors);
    setIsLoading(false);
    if (Object.keys(newErrors).length === 0) {
      await onSubmit(values);
    }
  };

  return { values, errors, isLoading, handleChange, handleSubmit };
};

export default useForm;
